import React from "react";
import style from '../../styles/applicationweek.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from '../CustomImage';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import router from 'next/router';
import useZipmeLink from "../../hooks/useZipmeLink";
import { getMobileImageUrl, isFrappeOrJotFormClass } from "../../utils/helpers";
import Head from "next/head";

interface Props {
    data: any;
    jotformId: string;
    externalLink: any;
}

const Appliactionweekheader: React.FC<Props> = ({ data, jotformId, externalLink }) => {
    const { zipmeLink, generateLink } = useZipmeLink();

    return (
        <>
            <Head>
                <link
                    rel="preload"
                    as="image"
                    href={data?.mainImageUrl?.imageUrl || '/images/admissionsday/university_logoImage.svg'}
                    imageSrcSet={`${getMobileImageUrl(data?.mainImageUrl?.imageUrl) || '/images/admissionsday/university_logoImage.svg'} 640w`}
                    imageSizes="(max-width: 767px) 640px, 100vw"
                    fetchPriority="high"
                />
            </Head>
            <div className={style.banner} >
                <Container>
                    <div className={style.nav}>
                        <Row>
                            <Col>
                                <Nav>
                                    <CustomImage src={data?.kcImageUrl?.imageUrl || "/images/educationfair/kc_logo.svg"} width={180} height={45} className={style.navLogo} alt={data?.kcImageUrl?.alt} />
                                </Nav>
                            </Col>
                        </Row>
                    </div>
                    <div className={style.maincontent}>
                        <Row>
                            <div className="d-block d-sm-none text-center mb-4">
                                <Col xl={6} lg={6} md={12} xs={12}>
                                    <div className={style.bannerStudDiv}>
                                        <div className={style.bg}>
                                            <CustomImage src={getMobileImageUrl(data?.mainImageUrl?.imageUrl) || "/images/admissionsday/university_logoImage.svg"} width={567} height={427} className={style.cardImg} layout="responsive" alt={data?.mainImageUrl?.alt} />
                                        </div>
                                    </div>
                                </Col>
                            </div>
                            <Col xl={6} lg={6} md={7} xs={12}>
                                <div className={style.fairdetails}>
                                    <div className={style.heading}>
                                        <h1 style={{ color: data?.titleColor || "#fff" }}>{data?.titleLineOne} <br /> {data?.titleLineTwo}</h1>
                                        <p style={{ color: data?.subTitleColor || "#fff" }}> {data?.subTitle}</p>
                                        <ul className={style.ulli}>
                                            <li style={{ color: data?.pointsColor || "#fff" }}><CustomImage src={data?.dateImageUrl} width={26} height={26} alt="dateicon.png" /><div>{data?.dateText}</div></li>
                                            <li style={{ color: data?.pointsColor || "#fff" }}><CustomImage src={data?.timeImageUrl} width={26} height={26} alt="timeicon" /><div>{data?.timeText}</div></li>
                                            <li style={{ color: data?.pointsColor || "#fff" }}><CustomImage src={data?.locationImageUrl} width={26} height={26} alt="addressicon" /><div>{data?.locationText}</div></li>
                                        </ul>
                                    </div>
                                    <div className={style.regBtn}>
                                        <Button onClick={() => {
                                            !jotformId && generateLink(externalLink);
                                        }}
                                            className={`${style.btnReg}${jotformId
                                                ? ` ${isFrappeOrJotFormClass(jotformId)}`
                                                : ''
                                                }`}
                                        >
                                            Register Now
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={5} xs={12}>
                                <div className="d-none d-sm-block text-center mb-4">
                                    <div className={style.bannerStudDiv}>
                                        <div className={style.bg}>
                                            <CustomImage src={data?.mainImageUrl?.imageUrl || "/images/admissionsday/university_logoImage.svg"} width={567} height={427} className={style.cardImg} layout="responsive" alt={data?.mainImageUrl?.alt} />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container >
            </div >
        </>
    )
}
export default Appliactionweekheader;